import React from 'react';
import r2wc from '@r2wc/react-to-web-component';
import { getWebComponentName } from '../utils';
// import { Button } from '@adc/ui-adc'
import Button from '@adc/ui-core/components/elementals/button';
const WrappedComponent = props => {
    const { caption, ...rest } = props;
    return (React.createElement(Button, { ...rest },
        React.createElement("span", null, caption)));
};
const WebButton = r2wc(WrappedComponent, {
    props: {
        role: 'string',
        caption: 'string',
        disabled: 'boolean',
        color: 'string',
    },
});
customElements.define(getWebComponentName('button-no-slots'), WebButton);
